import styled from "styled-components";


export const InfoContainer = styled.div`

	background: #FFFFFF 0% 0% no-repeat padding-box;
  opacity: 1;
  height: 600px;
  position: relative;
  justify-content: center;

  :before {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
    background: #276795 0% 0% no-repeat padding-box;
    mix-blend-mode: multiply;
    opacity: 1;
		z-index:2;
	}

	@media screen and (max-width: 768px) {
		padding: 0 0;
    height: 480px;
	}

`;
export const ContainAll = styled.div`

`

export const InfoBg = styled.div`
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	width: 100%;
	height: 100%;
	overflow: hidden;
`
export const ImageBg = styled.img`
	width: 100%;
	height: 100%;
	-o-object-fit:cover;
	object-fit: cover;
	background: #232a34;
`


export const InfoContent = styled.div`
	z-index: 3;
	max-width: 1200px;
	position: absolute;
	padding: 8px 24px;
  left: 40%;
  top: 15%;
	display: flex;
	flex-direction: column;
  @media screen and (max-width: 768px) {
    right: 16%;
    bottom: 25%;
	}
  @media screen and (max-width: 480px) {
    right: 0%;
    left: 58%;
    bottom: 25%;
    padding: 0;
	}
`;
export const InfoH1 =styled.h1`
	color: #fff;
  font: normal normal bold 70px "Spoqa Han Sans Neo";
	
	@media screen and (max-width: 768px) {
	  font: normal normal bold 45px "Spoqa Han Sans Neo";

	}

	@media screen and (max-width: 480px) {
	  font: normal normal bold 22px "Spoqa Han Sans Neo";

	}
`

export const InfoP = styled.p`
	margin-top: 24px;
  font: normal normal 300 32px "Spoqa Han Sans Neo";
	color: #fff;

	max-width: 600px;
	
	@media screen and (max-width: 768px) {
    font: normal normal 300 24px "Spoqa Han Sans Neo";
	}

	@media screen and (max-width: 480px) {
    font: normal normal 300 16px "Spoqa Han Sans Neo";
		
	}
`

export const InfoBtnWrapper = styled.div`
	display: inline-block;
	flex-direction: column;
	align-items: center;
`
export const AnotherInfoContent =styled.div`
	z-index: 3;
  width: 30%;
	max-width: 1200px;
	position: absolute;
	padding: 8px 24px;
  left: 40%;
  top: 50%;
	display: inline-block;
	flex-direction: column;
	align-items: center;
  @media screen and (max-width: 768px) {
    right: 15%;
    left: 55%;
    bottom: 15%;
    padding: 0;
	}
`
export const Img1 = styled.img`
  height: 480px;
  width: 230px;
  left: 20%;
  top: 10%;
  position: absolute;
  z-index: 5;
  @media screen and (max-width: 768px){
		margin-left: 0rem;
    margin-top: 2rem;
    left: 1%;
    margin-bottom: 15px;
	}
  @media screen and (max-width: 480px){
		margin-left: 1.5rem;
    margin-top: 2.3rem;
    left: 1%;
    margin-bottom: 15px;
    width: 40%;
    height: 60%;
	}
`;
export const ImgWrap =styled.div`
	max-width: 240px;
  max-height: 550px;
  
`;

export const Img = styled.img`
  top:11.9%;
  height: 457px;
  position: absolute;
  width: 215px;
  z-index: 5;
  left: 20.5%;
  border-radius: 25px;
  @media screen and (max-width: 768px){
		margin-left: 0rem;
    margin-top: 2rem;
    margin-bottom: 15px;
    left: 2%;
	}
  @media screen and (max-width: 480px){
		margin-left: 3rem;
    margin-top: 2rem;
    margin-bottom: 15px;
    width: 150px;
    height: 300px;
	}
`;